import React, { useState } from 'react';
import styled from 'styled-components';
import { CButton, CLink, Text } from '@appcues/component-library';
import { CLICKED_BUTTON } from 'constants/events';
import EmptyState from 'components/Common/EmptyState';

function NpsEmptyState({
  conditions,
  createSatisfactionWithRule,
  meta = {},
  onCreateCallback,
  rule,
  stepId,
  trackEvent,
}) {
  const [clicked, setClicked] = useState(false);

  const createNPSSurvey = () => {
    setClicked(true);

    trackEvent(CLICKED_BUTTON, {
      buttonLabel: 'Create Your NPS Survey',
    });

    return new Promise((resolve, reject) => {
      if (stepId !== 'new') {
        reject(new Error('Failed to create NPS survey'));
      } else {
        createSatisfactionWithRule(rule, conditions);
        if (onCreateCallback) {
          onCreateCallback();
        }
        resolve();
      }
    });
  };

  const isNPSProductTrial = meta.isNPSProductTrial && !meta.stripePlanId;
  const isNPSCustomer = meta.isNPSProductOnlyUser;

  return (
    <EmptyState header="Create an NPS Survey" iconName="comment-alt">
      <Text>
        Start collecting feedback from your users in just five minutes. See
        scores and feedback, along with a rolling NPS score, all within the
        dashboard.
      </Text>
      <Text>
        <CLink href="https://docs.appcues.com/article/497-nps-overview-2-0">
          Learn more about NPS with Appcues
        </CLink>
        .
      </Text>
      {isNPSProductTrial && !isNPSCustomer && (
        <Text className="satisfaction-intro-subtext paragraph-spacing-tight subtext">
          Appcues for NPS is free to try for 30 days!
        </Text>
      )}
      <CButton
        type="positive"
        onClick={createNPSSurvey}
        className="button-success create-nps-button"
        disabled={clicked}
      >
        Create Your NPS Survey
      </CButton>
    </EmptyState>
  );
}

export default styled(NpsEmptyState)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  text-align: center;

  .modal-dialog.large {
    overflow: visible;
  }

  .satisfaction-icon-container {
    position: relative;
    top: -175px;
    height: 0px;
    img {
      height: 155px;
      margin: 15px auto;
    }
  }

  .survey-background {
    height: 100%;
    width: 100%;
  }

  .modal-dialog.large {
    width: 750px;
    pointer-events: all;

    .base-modal-body {
      padding: 100px 0px 0px;
    }
  }

  .satisfaction-intro-header {
    margin-bottom: 11px;
    font-weight: 300;
    font-size: 36px;
    color: #06db82;
  }

  .satisfaction-intro-subtext {
    font-size: 18px;
    margin: 20px 40px 20px 50px;
    color: #717171;
    text-align: left;
  }

  .paragraph-spacing-tight {
    margin-top: 0px;
  }

  .subtext {
    font-style: italic;
  }

  .create-nps-button {
    margin: 15px auto;
    padding: 10px 15px;
  }
`;
